import React from 'react';
import { siteCopy } from '../../content/siteCopy';
import { focusedToolLotties } from '../../constants/toolIcons';
import ModuleLottieIcon from '../Global/ModuleLottieIcon';

const TOOL_COL_CLASS =
  'col-6 col-md-4 col-lg-3 col-xl-3 program_tool_col';

const Program = () => {
  const { programSection, focusedTools } = siteCopy;

  return (
    <section className="row_am program_section">
      <div className="container">
        <div
          className="section_title"
          data-aos="fade-up"
          data-aos-duration={1500}
          data-aos-delay={100}
        >
          <span className="title_badge">{programSection.badge}</span>
          <h2>{programSection.title}</h2>
          <p>{programSection.intro}</p>
        </div>
        <div className="program_blocks">
          <div className="row justify-content-center program_tools_row">
            {focusedTools.map((tool, index) => (
              <div key={tool.label} className={TOOL_COL_CLASS}>
                <div className="program_box">
                  <div className="program_icon">
                    <ModuleLottieIcon
                      animationData={focusedToolLotties[index]}
                      size={46}
                    />
                  </div>
                  <div className="program_text">{tool.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Program;
